import { render, staticRenderFns } from "./custom-link.vue?vue&type=template&id=264ff956&scoped=true&"
import script from "./custom-link.vue?vue&type=script&lang=js&"
export * from "./custom-link.vue?vue&type=script&lang=js&"
import style0 from "./custom-link.vue?vue&type=style&index=0&id=264ff956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ff956",
  null
  
)

export default component.exports